import React from "react";

function Copyright() {
    return (
        "Copyright 2017 - " + new Date().getFullYear() + " J.K. Smith Holding B.V. All rights reserved."
    );
}

export default React.memo(Copyright);
